import { createFileRoute } from "@tanstack/react-router";
import { LoginsRoute, loginsRouteOptions } from "@/features/managed-accounts";

export const Route = createFileRoute("/settings/logins")({
    ssr: loginsRouteOptions.ssr,
    loader: loginsRouteOptions.loader,
    head: loginsRouteOptions.head,
    component: LoginsRoute,
});
